module.exports = __webpack_public_path__ + "img/agent-knowledge.402fa6e5.webp";